<script setup lang="ts">
import Button from 'primevue/button';
import { computed } from 'vue';
import { formatFileSize } from '../helpers/file-size';

const props = withDefaults(
    defineProps<{
        filename?: string | null;
        fileSize?: string | number | null;
        hideFileSize?: boolean;
        downloadable?: boolean;
        loading?: boolean;
        downloaded?: boolean;
    }>(),
    {
        filename: null,
        fileSize: null,
    }
);

const emit = defineEmits<{
    (e: 'download', event: MouseEvent): void;
}>();

const showFileSize = computed(
    () => !props.hideFileSize && props.fileSize !== null
);

const fileSizeLabel = computed(() => {
    if (props.fileSize === null) return null;
    return formatFileSize(Number(props.fileSize));
});
</script>

<template>
    <div class="downloadable-file-list-item">
        <div class="downloadable-file-description py-2">
            <i class="file-icon pi pi-file mx-1" />
            <span
                class="filename mx-1"
                :class="{ 'text-300': props.filename == null }"
                >{{ props.filename ?? '--geen naam--' }}</span
            >
            <span v-if="showFileSize" class="filesize text-400">{{
                fileSizeLabel
            }}</span>
        </div>
        <div class="downloadable-file-actions">
            <Button
                :disabled="!downloadable"
                class="p-button-text"
                label="Download"
                :icon="downloaded ? 'pi pi-check' : 'pi pi-download'"
                :loading="loading"
                @click="emit('download', $event)"
            />
        </div>
    </div>
</template>

<style lang="scss">
.downloadable-file-list-item {
    display: flex;
    align-items: center;
    width: 100%;

    .downloadable-file-description {
        flex-grow: 1;
        flex-shrink: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;

        .filename {
            white-space: nowrap;
            font-weight: 500;
        }
        .filesize {
            margin-left: 0.25rem;
            font-size: smaller;
        }
    }
    .downloadable-file-actions {
        flex-grow: 0;
        flex-shrink: 0;
    }
}
</style>
